import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './_guards/auth.guard';
import {LoadGuard} from './_guards/load.guard';
import {ExportGuard} from './_guards/export.guard';
import {DashboardComponent} from './shared/dashboard/dashboard.component';
import {AuthenticatedUserComponent} from './public/authenticated-user/authenticated-user.component';
import {SignInComponent} from './public/sign-in/sign-in.component';
import {TermsConditionsComponent} from './shared/components/terms-conditions/terms-conditions.component';
import {CaseDetailComponent} from './shared/components/case-detail/case-detail.component';
import {ErrorNotFoundComponent} from './shared/components/error-not-found/error-not-found.component';
import {RedirectComponent} from './shared/components/redirect/redirect.component';
import {FileTabGroupComponent} from './shared/components/file-tab-group/file-tab-group.component';

const routes: Routes = [
  {path: 'redirecting-user', component: RedirectComponent},
  {path: 'login', component: SignInComponent},
  {path: 'authenticated-user', component: AuthenticatedUserComponent},
  {path: 'cases', component: DashboardComponent, canLoad: [LoadGuard], canActivate: [AuthGuard]},
  {path: 'case/:id', component: CaseDetailComponent, canLoad: [LoadGuard], canActivate: [AuthGuard]},
  {path: 'tab/:index', component: FileTabGroupComponent, canLoad: [LoadGuard], canActivate: [ExportGuard]},
  {
    path: 'core',
    loadChildren: () => import('./core/core.module').then(mod => mod.CoreModule),
    canLoad: [LoadGuard],
    canActivate: [AuthGuard]
  },
  {path: 'terms', component: TermsConditionsComponent},
  {path: 'error', component: ErrorNotFoundComponent},
  {path: '', redirectTo: 'redirecting-user', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {enableTracing: false} // <-- debugging purposes only
  )],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
